import { render, staticRenderFns } from "./AsociaDesasociaRol.vue?vue&type=template&id=ad55a572"
import script from "./AsociaDesasociaRol.vue?vue&type=script&lang=js"
export * from "./AsociaDesasociaRol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports